var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.933 16.933",
    id: "TxtFile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.968,
    transform: "matrix(1.03366 0 0 1.03333 -2.911 3.935)",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.9217235,-3.8085938 A 0.25603411,0.25603411 0 0 0 4.6658641,-3.5527344 V 12.322266 a 0.25603411,0.25603411 0 0 0 0.2558594,0.255859 H 17.093598 a 0.25603411,0.25603411 0 0 0 0.255859,-0.255859 V 1.3886719 a 0.25603411,0.25603411 0 0 0 -0.07227,-0.1796875 l -4.796875,-4.9179688 v -0.00195 a 0.25600851,0.25600851 0 0 0 -0.01953,-0.019531 0.25600851,0.25600851 0 0 0 -0.02149,-0.019531 0.25600851,0.25600851 0 0 0 -0.02344,-0.017578 0.25600851,0.25600851 0 0 0 -0.02344,-0.013672 0.25600851,0.25600851 0 0 0 -0.01367,-0.00586 0.25600851,0.25600851 0 0 0 -0.02539,-0.00977 0.25600851,0.25600851 0 0 0 -0.01367,-0.00391 0.25600851,0.25600851 0 0 0 -0.0059,0 0.25600851,0.25600851 0 0 0 -0.03711,-0.00586 0.25600851,0.25600851 0 0 0 -0.01367,-0.00195 0.25600851,0.25600851 0 0 0 -0.0059,0 h -0.0078 z m 0.2558594,0.5117188 h 6.9902341 l 4.669922,4.7890625 V 12.066406 H 5.1775829 Z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.269531 -3.8085938 A 0.25603411 0.25603411 0 0 0 12.021484 -3.5527344 L 12.021484 1.3886719 A 0.25603411 0.25603411 0 0 0 12.277344 1.6445312 L 17.09375 1.6445312 A 0.25603411 0.25603411 0 0 0 17.277344 1.2089844 L 12.460938 -3.7304688 A 0.25603411 0.25603411 0 0 0 12.269531 -3.8085938 z M 12.533203 -2.921875 L 16.488281 1.1328125 L 12.533203 1.1328125 L 12.533203 -2.921875 z ",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      lineHeight: 2,
      InkscapeFontSpecification: "Calibri",
      textAlign: "center"
    },
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.265,
    "aria-label": "TXT",
    fontFamily: "Calibri",
    fontSize: 5.292,
    opacity: 0.99,
    textAnchor: "middle",
    className: "colorStroke000000 svgStroke"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#437ef7",
    stroke: "none",
    d: "M7.0507318 12.012185q0 .04909-.00517.08527-.00517.03617-.018087.05943-.010335.02067-.028422.03101-.015503.01034-.036174.01034H6.0223701v2.899049q0 .02067-.010335.03617-.010335.0155-.036174.02584-.025838.0078-.069763.01292-.041341.0078-.1059368.0078-.062012 0-.1059367-.0078-.043925-.0052-.069763-.01292-.025838-.01033-.036174-.02584-.010335-.0155-.010335-.03617V12.198221H4.6374409q-.020671 0-.038757-.01034-.015503-.01033-.025838-.03101-.010335-.02325-.018087-.05943-.00517-.03617-.00517-.08527 0-.04909.00517-.08527.00775-.03876.018087-.06201.010335-.02325.025838-.03359.018087-.01033.038757-.01033h2.3254409q.020671 0 .036174.01033.018087.01034.028422.03359.012919.02325.018087.06201.00517.03617.00517.08527zM9.6681447 15.004253q.03359.05684.038757.09043.00775.03359-.015503.05426-.023254.01809-.077515.02325-.051676.0078-.1395265.0078-.082682 0-.1291911-.0052-.046509-.0026-.074931-.01292-.025838-.01033-.041341-.02326-.012919-.0155-.023254-.03876L8.4614992 13.769185 7.7096067 15.099854q-.012919.02325-.028422.03876-.015503.0155-.043925.02584-.025838.0078-.072347.01033-.046509.0052-.1240235.0052-.085266 0-.1343588-.0078-.049093-.0052-.069763-.02325-.018087-.02067-.012919-.05426.00775-.03359.041341-.09043L8.1772787 13.466878 7.3065303 11.98118q-.031006-.05685-.041341-.09043-.00775-.03617.012919-.05426.020671-.02067.072347-.02584.051676-.0052.1421103-.0052.077515 0 .1266073.0052.049093.0026.077515.01292.028422.0078.041341.02584.012919.0155.028422.03617l.7183029 1.250571.7131351-1.250571q.012919-.02067.025838-.03617.012919-.01809.036174-.02584.025838-.01033.069763-.01292.043925-.0052.1188559-.0052.080099 0 .1291912.0078.051676.0052.072347.02325.023254.01809.018087.05426-.00517.03359-.036174.09043l-.8681645 1.475363zM12.383743 12.012185q0 .04909-.0052.08527-.0052.03617-.01809.05943-.01034.02067-.02842.03101-.0155.01034-.03617.01034h-.940512v2.899049q0 .02067-.01033.03617-.01033.0155-.03617.02584-.02584.0078-.06976.01292-.04134.0078-.105937.0078-.06201 0-.105936-.0078-.04392-.0052-.06976-.01292-.02584-.01033-.03617-.02584-.01033-.0155-.01033-.03617V12.198221H9.9704521q-.020671 0-.038757-.01034-.015503-.01033-.025838-.03101-.010335-.02325-.018087-.05943-.00517-.03617-.00517-.08527 0-.04909.00517-.08527.00775-.03876.018087-.06201.010335-.02325.025838-.03359.018087-.01033.038757-.01033h2.3254409q.02067 0 .03617.01033.01809.01034.02842.03359.01292.02325.01809.06201.0052.03617.0052.08527z",
    fontWeight: 400,
    className: "color000000 svgShape"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.2868a2d1812511858b9eaa2923082407.svg";
export { ForwardRef as ReactComponent };